import { Component, input, output } from '@angular/core';
import { ModalService } from 'src/app/project/components/modal/modal.service';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { CustomFieldsService } from '../../../custom-fields/custom-fields.service';
import { TDashletSiteRange } from '../../../preferences/preferences.model';

@Component({
  selector: 'pp-new-dashlet-modal-value-breakdown-fields',
  templateUrl: './new-dashlet-modal-value-breakdown-fields.component.html',
  styleUrl: './new-dashlet-modal-value-breakdown-fields.component.scss',
  standalone: false,
})
export class NewDashletModalValueBreakdownFieldsComponent {
  ppAssetId = input<string>();
  ppNewDashlet = input<boolean>();
  ppInitialRange = input<TDashletSiteRange>();
  ppInitialName = input<string>();
  ppAddDashlet = output<{
    selectedRange: TDashletSiteRange;
    customName: string;
  }>();
  ppGoBack = output<void>();
  ppDeleteDashlet = output<void>();

  EIconPath = EIconPath;
  selectedRange: TDashletSiteRange = {
    workspaceId: null,
    numericalCustomFieldId: null,
    listCustomFieldId: null,
  };
  isDisabled = false;
  errorMessages: string[] = [];
  customName: string;

  headerText: string;
  confirmButtonText: string;

  constructor(
    private modalService: ModalService,
    private customFieldsService: CustomFieldsService,
    private translationPipe: TranslationPipe,
  ) {}

  ngOnChanges(): void {
    this.setHeader();
    this.setConfirmButtonText();
    this.checkErrors();
  }

  ngOnInit(): void {
    if (this.ppInitialRange()) {
      this.selectedRange = this.ppInitialRange();
    } else {
      this.selectedRange = {
        workspaceId: null,
        numericalCustomFieldId: null,
        listCustomFieldId: null,
      };
    }

    if (this.ppInitialName()) {
      this.customName = this.ppInitialName();
    } else {
      this.customName = '';
    }
  }

  hideModal(): void {
    this.modalService.hideModal();
  }

  addDashlet(): void {
    this.ppAddDashlet.emit({
      selectedRange: this.selectedRange,
      customName: this.customName,
    });
  }

  goBack(): void {
    this.ppGoBack.emit();
  }

  deleteDashlet(): void {
    this.ppDeleteDashlet.emit();
  }

  selectSite(workspaceId: string): void {
    if (workspaceId !== this.selectedRange.workspaceId) {
      this.selectedRange.numericalCustomFieldId = null;
      this.selectedRange.listCustomFieldId = null;
    }

    this.selectedRange.workspaceId = workspaceId;

    this.checkErrors();
  }

  private setHeader(): void {
    this.headerText = this.ppNewDashlet()
      ? this.translationPipe.transform('add_dashlet_value_breakdown')
      : this.translationPipe.transform('edit_dashlet_value_breakdown');
  }

  private setConfirmButtonText(): void {
    this.confirmButtonText = this.ppNewDashlet()
      ? this.translationPipe.transform('add_dashlet')
      : this.translationPipe.transform('update_dashlet');
  }

  checkErrors(): void {
    const errorMessages: string[] = [];
    const listCustomFieldId = this.selectedRange.listCustomFieldId;
    const numericalCustomFieldId = this.selectedRange.numericalCustomFieldId;

    const listCustomField = this.customFieldsService.getWorkspaceCustomField(
      this.selectedRange.workspaceId,
      listCustomFieldId,
    );
    const numericalCustomField = this.customFieldsService.getWorkspaceCustomField(
      this.selectedRange.workspaceId,
      numericalCustomFieldId,
    );

    if (!listCustomField && listCustomFieldId) {
      errorMessages.push(
        this.translationPipe.transform('error_custom_field_not_found', {
          fieldType: this.translationPipe.transform('list_field'),
        }),
      );
    }

    if (!numericalCustomField && numericalCustomFieldId) {
      errorMessages.push(
        this.translationPipe.transform('error_custom_field_not_found', {
          fieldType: this.translationPipe.transform('numerical_field'),
        }),
      );
    }

    this.errorMessages = errorMessages;
    this.isDisabled =
      errorMessages.length > 0 ||
      !this.selectedRange.workspaceId ||
      !listCustomFieldId ||
      !numericalCustomFieldId;
  }
}
